module.exports = __webpack_public_path__ + "img/img-26.7a6893ff.png";